<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding:20px;width:100%;box-sizing: border-box;">
      <el-button size="small" @click="back" icon="el-icon-arrow-left" class="back">返回</el-button>
      <el-row class="mt2" type="flex" justify="center" style="background:#fff;padding:35px 0 20px 0;">
        <el-col :span="8" style="position: relative;">
          <el-steps :active="active" process-status="success" :align-center="true">
            <el-step title="待提交"></el-step>
            <el-step title="已提交"></el-step>
            <el-step title="订单已审核"></el-step>
            <el-step title="已配车"></el-step>
          </el-steps>
          <img v-if="form.extOrderId" style="position: absolute; top: -35px; right: -60px;" :src="customerOrder.isLocked ? locked : unlocked" width="80px" height="80px" alt="">
        </el-col>
      </el-row>
      <el-row class="mt1" type="flex" justify="space-between">
        <el-col :span="17">
          <el-form ref="form" :inline="true" label-position="right" :model="form" :rules="formRules" label-width="120px">
            <el-row type="flex" justify="space-between" align="middle">
              <div class="title" style="width:150px">
                车辆信息<span @click="toCustomer" style="color:#409EFF" v-if="formName != 'customerDetail'"
                  class="toCustomer">客户详情</span>
              </div>
              <el-form-item class="form_item" label-width="260px" v-if="form.extOrderId != ''"
                :label="'销售订单号:' + form.extOrderId">
                <div style="color:#409EFF;cursor: pointer;" v-if="allowTransferAudit" @click="transferAudit = true">
                  线上订单异常申请？
                </div>
              </el-form-item>
              <div style="display:flex;height:30px">
                <el-button size="mini" v-if="disabled" style="margin-right:10px !important;" @click="orderCancel">订单取消
                </el-button>
                <el-button size="mini" @click="disabled = false" v-if="disabled" style="margin-right:10px !important;">
                  修改</el-button>
                <el-button size="mini" @click="Cancel" v-if="!disabled && !confirmLoading"
                  style="margin-right:10px !important;">取消
                </el-button>
                <el-button size="mini" @click="Save" :loading="confirmLoading" v-if="!disabled">保存</el-button>
                <el-button size="mini" v-if="disabled" style="margin-left:10px !important;" @click="handleSubmit">提交</el-button>
              </div>
            </el-row>
            <el-row style="background:#fff;padding:15px 0;">
              <el-form-item class="form_item" label="订单类型" prop="orderType">
                <el-select size="mini" style="width:160px;" :disabled="disabled" placeholder="请选择"
                  v-model="form.orderType">
                  <el-option v-for="item in orderTypeDics" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="订购车型" prop="modelId">
                <el-cascader size="mini" class="filter-item" :disabled="disabled" style="width: 330px;"
                  placeholder="选择订购车型" filterable :show-all-levels="true" :options="carOptions" v-model="form.modelId"
                  @change="changeSpecColor"></el-cascader>
              </el-form-item>
              <el-form-item class="form_item" label="车辆状态" v-if="form.otdStatus != ''">
                <div style="width:160px;">{{ form.otdStatus }}</div>
              </el-form-item>
              <el-form-item class="form_item" label="外观颜色" prop="modelColor">
                <el-select size="mini" style="width:160px;" :disabled="disabled" placeholder="请选择"
                  v-model="form.modelColor" @change="modelColorChange">
                  <el-option v-for="(item, index) in colors" :key="index" :label="item.color + '(' + item.total + ')'"
                    :value="item.color"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="内饰">
                <el-select size="mini" :disabled="disabled" style="width:160px;" placeholder="请选择"
                  v-model="form.carInternalColor" @change="carInternalColorChange">
                  <el-option v-for="(item, index) in carInternalColor" :key="index" :label="item === '' ? '无' : item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item v-for="(options, key) in carModelOptionalsComputed" :key="key" class="form_item" :label="modelOptionalsKeyMap.get(key)">
                <el-select
                  size="mini"
                  :disabled="disabled"
                  style="width: 160px"
                  placeholder="请选择"
                  v-model="form.carModelOptionals[key]"
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="index"
                    :value="item === '无选装' ? '' : item"
                    :label="item === '' ? '无' : item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item class="form_item"
                            label="车架号">
                <el-select size="mini"
                           style="width:160px;"
                           :disabled="disabled"
                           placeholder="请选择"
                           v-model="form.modelVin">
                  <el-option v-for="item in vins"
                             :key="item.vin"
                             :label="item.vin"
                             :value="item.vin"></el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item class="form_item"
                            label="是否三包车"
                            prop="isSanbao">
                <el-select size="mini"
                           style="width:160px;"
                           :disabled="disabled"
                           placeholder="请选择"
                           v-model="form.isSanbao">
                  <el-option :value="true"
                             label="是"></el-option>
                  <el-option :value="false"
                             label="否"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item class="form_item" label="订金" prop="paymentDown">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  v-model="form.paymentDown"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="收款方式" prop="payType">
                <el-select size="mini" style="width:160px;" :disabled="disabled" placeholder="请选择" v-model="form.payType">
                  <el-option label="全款" :value="1"></el-option>
                  <el-option label="按揭" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item class="form_item"
                            label="首付金额"
                            v-if="form.payType === 2">
                <el-input size="mini"
                          style="width: 160px;"
                          :disabled="disabled"
                          placeholder="请输入"
                          v-model="form.paymentFirst"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="按揭金额"
                            v-if="form.payType === 2">
                <el-input size="mini"
                          style="width: 160px;"
                          :disabled="disabled"
                          placeholder="请输入"
                          v-model="form.mortgagePayment"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            v-if="form.payType === 2"
                            label="按揭期数">
                <el-select size="mini"
                           style="width:160px;"
                           :disabled="disabled"
                           placeholder="请选择"
                           v-model="form.paymentYears">
                  <el-option v-for="item in orderLoadDurationDics"
                             :key="item.dataValue"
                             :label="item.dataDisplay"
                             :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="成交金额"
                            prop="paymentDeal">
                <el-input size="mini"
                          style="width: 160px;"
                          :disabled="disabled"
                          placeholder="请输入"
                          v-model="form.paymentDeal"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="其他费用">
                <el-input size="mini"
                          style="width: 160px;"
                          :disabled="disabled"
                          placeholder="请输入"
                          v-model="form.paymentOther"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="车辆用途"
                            prop="vehiclePurpose">
                <el-select size="mini"
                           style="width:160px;"
                           :disabled="disabled"
                           placeholder="请选择"
                           v-model="form.vehiclePurpose">
                  <el-option v-for="item in orderVehiclePurposeDics"
                             :key="item.dataValue"
                             :label="item.dataDisplay"
                             :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="是否置换"
                            prop="isReplace">
                <el-select size="mini"
                           style="width:160px;"
                           :disabled="disabled"
                           placeholder="请选择"
                           v-model="form.isReplace">
                  <el-option :value="true"
                             label="是"></el-option>
                  <el-option :value="false"
                             label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="置换车牌号"
                            v-if="form.isReplace"
                            prop="replacedCarNum">
                <el-input size="mini"
                          style="width: 160px;"
                          :disabled="disabled"
                          maxlength="8"
                          placeholder="请输入"
                          v-model="form.replacedCarNum"></el-input>
              </el-form-item>
              <el-form-item class="form_item"
                            label="是否二级店销售">
                <el-select size="mini"
                           style="width:160px;"
                           :disabled="disabled"
                           placeholder="请选择"
                           v-model="form.isSaledBySecond">
                  <el-option :value="true"
                             label="是"></el-option>
                  <el-option :value="false"
                             label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item"
                            label="二级店名称"
                            v-if="form.isSaledBySecond"
                            prop="secondDealerName">
                <el-select size="mini"
                           :disabled="disabled"
                           style="width:160px;"
                           placeholder="请选择"
                           v-model="form.secondDealerName">
                  <el-option v-for="item in secondDealers"
                             :key="item"
                             :label="item"
                             :value="item"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item class="form_item" label="预计交车时间">
                <el-date-picker size="mini" style="width:160px;" :disabled="disabled" :picker-options="pickerOptions"
                  v-model="form.deliverDate" :clearable="false" type="date" value-format="timestamp" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="form_item" label="订车原因">
                <el-select size="mini" style="width:200px;" placeholder="请选择" :disabled="disabled"
                  v-model="form.orderReason" multiple>
                  <el-option v-for="(item, index) in failProductReasonDics" :key="index" :label="item.dataName"
                    :value="item.dataName"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="对比车型">
                <el-select size="mini" style="width:250px;" placeholder="请选择" :disabled="disabled"
                  v-model="form.competeSeriesId">
                  <el-option v-for="(item, index) in competitionSeries" :key="index"
                    :label="item.brandName + ' ' + item.seriesName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" label="购车类型" prop="businessType">
                <el-select size="mini" style="width:160px;" :disabled="disabled" placeholder="请选择"
                  v-model="form.businessType">
                  <el-option v-for="item in businessTypeOptions" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row style="margin-top:10px">
              <div class="title">客户信息</div>
            </el-row>
            <el-row style="background:#fff;padding:15px 0;">
              <el-form-item class="form_item" label="类型" prop="customerType">
                <el-select size="mini" style="width:160px;" :disabled="disabled" placeholder="请选择"
                  @change="customerTypeChange" v-model="form.customerType">
                  <el-option label="个人" :value="1"></el-option>
                  <el-option label="企业" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" :label="form.customerType === 1 ? '订车人姓名' : '公司名称'" prop="customerName">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  v-model.trim="form.customerName"
                  onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="联系电话" prop="customerPhone">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  v-model="form.customerPhone"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="证件类型" prop="identifyType">
                <el-select size="mini" :disabled="disabled" @change="identifyTypeChange" style="width:160px;"
                  placeholder="请选择" v-model="form.identifyType">
                  <el-option v-for="item in orderIdentifyTypeDics" :key="item.dataValue" :label="item.dataDisplay"
                    :value="item.dataValue"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form_item" v-if="form.identifyType === 1" label="证件号码" prop="identifyNo">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"
                  onkeyup="this.value = this.value.toUpperCase()" v-model.trim="form.identifyNo"></el-input>
              </el-form-item>
              <el-form-item class="form_item" v-if="form.identifyType === 2" label="证件号码" prop="identifyNo2">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  v-model.trim="form.identifyNo2" onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"
                  onkeyup="this.value = this.value.toUpperCase()"></el-input>
              </el-form-item>
              <el-form-item class="form_item" v-if="form.identifyType === 3" label="证件号码" prop="identifyNo3">
                <el-input size="mini" :disabled="disabled" style="width: 160px;" placeholder="请输入"
                  v-model.trim="form.identifyNo3" onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"
                  onkeyup="this.value = this.value.toUpperCase()"></el-input>
              </el-form-item>
              <el-form-item class="form_item" v-if="form.identifyType != 1 &&
                form.identifyType != 2 &&
                form.identifyType != 3
                " label="证件号码" prop="identifyNos">
                <el-input size="mini" style="width: 160px;" :disabled="disabled" placeholder="请输入"
                  v-model.trim="form.identifyNos" onkeydown="if (event.keyCode===13 || event.keyCode===32){return false;}"
                  onkeyup="this.value = this.value.toUpperCase()"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="推荐人姓名" prop="referrerName">
                <el-input size="mini" disabled style="width: 160px;" placeholder="请输入"
                  v-model="form.referrerName"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="推荐人电话" prop="referrerPhone">
                <el-input size="mini" disabled style="width: 160px;" placeholder="请输入"
                  v-model="form.referrerPhone"></el-input>
              </el-form-item>
              <el-form-item class="form_item" label="省/市/区">
                <el-select size="mini" :disabled="disabled" style="width:100px;" placeholder="选择省" clearable
                  @change="provinceChange" v-model="form.customerProvince">
                  <el-option v-for="item in provinces" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select size="mini" style="width:100px;" :disabled="disabled" placeholder="选择市" clearable
                  @change="cityChange" v-model="form.customerCity">
                  <el-option v-for="item in citys" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-select size="mini" style="width:100px;" :disabled="disabled" placeholder="选择区" clearable
                  v-model="form.customerCounty">
                  <el-option v-for="item in countys" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <!-- <el-cascader :props="adressProps"
                             v-model="form.address"
                             size="mini"
                             v-if="show"
                             :disabled="disabled"
                             placeholder="请选择"
                             style="width:200px;"></el-cascader> -->
              </el-form-item>
              <el-form-item class="form_item" label="详细地址" prop="customerAddress">
                <el-input size="mini" :disabled="disabled" style="width: 300px;" placeholder="请输入"
                  v-model="form.customerAddress"></el-input>
              </el-form-item>
            </el-row>
            <el-row style="margin-top:10px">
              <div class="title">其他信息</div>
              <el-row style="background:#fff;padding:15px 0;">
                <!-- <el-form-item class="form_item"
                              label="转他店交付">
                  <el-select size="mini"
                             :disabled="disabled"
                             style="width:160px;"
                             placeholder="请选择"
                             v-model="form.isOtherDealer">
                    <el-option :value="true"
                               label="是"></el-option>
                    <el-option :value="false"
                               label="否"></el-option>
                  </el-select>
                </el-form-item> -->
                <!-- <el-form-item class="form_item"
                              label="锐见报表统计">
                  <el-select size="mini"
                             :disabled="disabled"
                             style="width:160px;"
                             placeholder="请选择"
                             v-model="form.isReport">
                    <el-option :value="true"
                               label="是"></el-option>
                    <el-option :value="false"
                               label="否"></el-option>
                  </el-select>
                </el-form-item> -->
                <!-- <el-form-item class="form_item"
                              label="下次跟进时间"
                              prop="nextFollowDate">
                  <el-date-picker size="mini"
                                  :disabled="disabled"
                                  style="width:160px;"
                                  :picker-options="pickerOptions"
                                  v-model="form.nextFollowDate"
                                  :clearable="false"
                                  type="date"
                                  value-format="timestamp"
                                  placeholder="选择日期"></el-date-picker>
                </el-form-item> -->
                <el-form-item class="form_item" label="成交渠道">
                  <el-input v-if="form.reactivateSource" size="mini" style="width: 160px;" v-model="form.reactivateSource" disabled></el-input>
                  <el-input v-else size="mini" style="width: 160px;" v-model="form.sourceName" disabled></el-input>
                </el-form-item>
                <el-form-item class="form_item" label="备注">
                  <el-input type="textarea" :disabled="disabled" style="width:330px;" :rows="2" placeholder="请输入备注内容"
                    v-model="form.remark"></el-input>
                </el-form-item>
              </el-row>
              <el-row style="background:#fff;padding:15px 0;">
                <el-col :span="12">
                  <el-form-item class="form_item" label="订车合同/协议(最多三张)" prop="images1">
                    <Upload ref="upload1" v-model="form.images1" :disabled="disabled"></Upload>
                    <!-- <el-upload action accept=".jpeg,.jpg,.png" :limit="3" :disabled="disabled" ref="upload1"
                      :file-list="fileList1" :on-remove="handleRemove1" :class="{ hide: hideUpload1 }"
                      :http-request="uploadRequest1" :on-success="handleUploadSuccess1" :on-change="handleUploadChange1"
                      :before-upload="uploadBefore" list-type="picture-card">
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                        <span class="el-upload-list__item-actions">
                          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview1(file)">
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span class="el-upload-list__item-delete" :disabled="disabled" @click="handleRemove1(file)">
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>
                      </div>
                      <div slot="tip" class="el-upload__tip">
                        支持JPG、JPEG、PNG格式
                      </div>
                    </el-upload> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item class="form_item" label="交易凭证">
                    <Upload ref="upload2" v-model="form.images2" :disabled="disabled"></Upload>
                    <!-- <el-upload action accept=".jpeg,.jpg,.png" :limit="3" ref="upload2" :disabled="disabled"
                      :file-list="fileList2" :class="{ hide: hideUpload2 }" :http-request="uploadRequest2"
                      :on-success="handleUploadSuccess2" :on-change="handleUploadChange2" :before-upload="uploadBefore"
                      list-type="picture-card">
                      <i slot="default" class="el-icon-plus"></i>
                      <div slot="file" slot-scope="{ file }">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                        <span class="el-upload-list__item-actions">
                          <span class="el-upload-list__item-preview" @click="handlePictureCardPreview2(file)">
                            <i class="el-icon-zoom-in"></i>
                          </span>
                          <span class="el-upload-list__item-delete" @click="handleRemove2(file)">
                            <i class="el-icon-delete"></i>
                          </span>
                        </span>
                      </div>
                      <div slot="tip" class="el-upload__tip">
                        支持JPG、JPEG、PNG格式
                      </div>
                    </el-upload> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="7" style="margin-left:20px">
          <div class="title">订单操作记录</div>
          <el-row style="min-height:196px;background:#fff">
            <el-timeline style="margin-top:15px;margin-left:30px">
              <el-timeline-item v-for="(item, index) in timelines" :key="index" color="#0bbd87"
                :timestamp="parseTime(item.createdAt, '{y}/{m}/{d} {h}:{i}')">
                <div class="boxLine">
                  <div class="title">{{ item.orderStatus | orderStatus }}</div>
                  <span v-html="item.content.replaceAll('\n', '<br/>')"></span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="取消订单" :visible.sync="orderCancelLog" width="500px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <el-form ref="orderCancelForm" :rules="orderCancelRules" label-position="right" :model="orderCancelForm"
        label-width="80px">
        <el-row>
          <el-form-item class="form_item_val" label="取消原因" prop="reason">
            <el-input type="textarea" :rows="4" placeholder="请输入取消订单原因" v-model="orderCancelForm.reason"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderCancelLog = false" type="text">取消</el-button>
        <el-button @click="orderCanceConfim" type="text" :loading="confirmLoading">确定</el-button>
      </span>
    </el-dialog>
    <!-- 提交审批 -->
    <el-dialog :visible.sync="SubmitLog" width="500px" title="是否提交管理层进行审批">
      <!-- 1、若订单未锁单，无论订单是否存在修改，则都需要核销； 
           2、若订单从C端同步过来后，订单存在修改更新，无论订单是否锁单，则需要核销。 -->
      <el-form label-position="left" label-width="80px" v-if="form.extOrderId != '' && (!customerOrder.isLocked || data.isUpdate)">
        <el-form-item class="form_item" label="核销码" prop="reason">
          <el-input placeholder="请输入" size="mini" style="width:200px" v-model="code"></el-input>
          <el-button @click="sendSms" v-show="isSend" type="primary" size="mini">发送</el-button>
          <el-button v-show="!isSend" type="primary" size="mini" disabled>{{ time }}s后重新发送</el-button>
        </el-form-item>
        <p class="pss">
          点击发送将发送核销码给到订单手机号码或客户“比亚迪汽车”小程序系统通知中
        </p>
        <div class="pss">{{ remark }}</div>
      </el-form>
      <div class="submit-fo" style="padding-bottom:10px">
        <el-button @click="SubmitLog = false" size="mini">取消</el-button>
        <el-button type="primary" style="margin-left:25px!important;" @click="Submit" :loading="subLoading" size="mini">
          确定</el-button>
      </div>
    </el-dialog>
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="fileList" :initialIndex="initialIndex" />
    <el-dialog title="取消订单" :visible.sync="orderCancelLog2" width="500px" :close-on-press-escape="false"
      :close-on-click-modal="false">
      <p>{{ cannotCancelMsg }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderCancelLog2 = false" type="text">我知道了</el-button>
      </span>
    </el-dialog>
    <!-- blc拦截弹窗 -->
    <blc-tips :visible.sync="showBlcTips" :info="blcInfo"></blc-tips>
  </div>
</template>

<script>
import ElImageViewer from "./image-viewer";
import oss from '../../assets/js/ali-oss';
import BlcTips from "@/components/blc-tips/index.vue";
import { remarkValidator, getUrls } from '@/assets/js/util'
import { modelOptionalsKeyMap, orderStatusDics } from './constants.js'
import Upload from "@/components/common/Upload.vue";
import locked from '../../assets/img/locked.svg'
import unlocked from '../../assets/img/unlocked.svg'
var order_vm;
export default {
  components: { ElImageViewer,BlcTips, Upload },
  data() {
    const validateIdentifyNo = (rule, value, callback) => {
      //15位和18位身份证号码的正则表达式
      var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      //如果通过该验证，说明身份证格式正确，但准确性还需计算
      if (regIdCard.test(value)) {
        if (value.length == 18) {
          var idCardWi = new Array(
            7,
            9,
            10,
            5,
            8,
            4,
            2,
            1,
            6,
            3,
            7,
            9,
            10,
            5,
            8,
            4,
            2
          ); //将前17位加权因子保存在数组里
          var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
          var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
          for (var i = 0; i < 17; i++) {
            idCardWiSum += value.substring(i, i + 1) * idCardWi[i];
          }
          var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
          var idCardLast = value.substring(17); //得到最后一位身份证号码
          //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
          if (idCardMod == 2) {
            if (idCardLast == "X" || idCardLast == "x") {
              callback();
            } else {
              callback(new Error("请输入合法证件号"));
            }
          } else {
            //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
            if (idCardLast == idCardY[idCardMod]) {
              callback();
            } else {
              callback(new Error("请输入合法证件号"));
            }
          }
        }
      } else {
        callback(new Error("请输入合法证件号"));
      }
    };
    const validateReplacedCarNum = (rule, value, callback) => {
      if (this.form.isReplace) {
        var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
        var creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
        if (value.length == 7) {
          if (creg.test(value)) {
            callback();
          } else {
            callback(new Error("请输入正确车牌号"));
          }
        } else if (value.length == 8) {
          if (xreg.test(value)) {
            callback();
          } else {
            callback(new Error("请输入正确车牌号"));
          }
        } else {
          callback(new Error("请输入正确车牌号"));
        }
      }
    };
    const validatePhTelNumber = (rule, value, callback) => {
      const telNumber = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (!telNumber.test(value)) {
        callback(new Error("请输入正确的联系电话"));
      } else {
        callback();
      }
    };
    order_vm = this;
    return {
      locked,
      unlocked,
      modelOptionalsKeyMap,
      showBlcTips: false,
      blcInfo: {},
      initialIndex: 0,
      isSend: true,
      time: 60,
      transferAudit: false,
      allowTransferAudit: false,
      needCheckOrder: false,
      allowCancel2: false, //是否允许关闭订单
      orderCancelLog2: false,
      cannotCancelMsg: "",
      code: "",
      remark: "",
      dealer: this.$common.getLoginInfo().profile,
      orderId: Number(this.$route.query.id),
      formName: sessionStorage.getItem("form"),
      active: 0,
      hideUpload1: false,
      fileList: [],
      fileList1: [],
      hideUpload2: false,
      fileList2: [],
      form: {
        otdStatus: "",
        orderType: "",
        modelId: [],
        modelColor: "",
        paymentDown: "",
        payType: 2,
        customerType: 1,
        customerName: "",
        customerPhone: "",
        identifyType: 1,
        identifyNo: "",
        identifyNos: "",
        identifyNo2: "",
        identifyNo3: "",
        customerAddress: "",
        // address: [],
        deliverDate: "",
        // isReport: true,
        nextFollowDate: "",
        remark: "",
        // mortgagePayment: '',
        images1: [],
        images2: [],
        customerProvince: "",
        customerCity: "",
        customerCounty: "",
        extOrderId: "",
        carInternalColor: '',
        carModelOptionals: {
          optional1: "",
          optional2: "",
          optional3: "",
          optional4: "",
          optional5: "",
          optional6: "",
          optional7: "",
          optional8: "",
          optional9: "",
        }, // 车型选装
        orderReason: [],
        competeSeriesId: '',
        businessType: '', // 购车类型
      },
      formRules: {
        contractNo: [
          {
            required: true,
            message: "请输入合同编号",
            trigger: "blur",
          },
        ],
        orderType: [
          {
            required: true,
            message: "请选择订单类型",
            trigger: "blur",
          },
        ],
        modelId: [
          {
            required: true,
            message: "请选择订购车型",
            trigger: "blur",
          },
        ],
        modelColor: [
          {
            required: true,
            message: "请选择外观颜色",
            trigger: "blur",
          },
        ],
        carInternalColor: [
          {
            required: true,
            message: "请选择内饰",
            trigger: "blur",
          },
        ],
        isSanbao: [
          {
            required: true,
            message: "请选择是否三包车",
            trigger: "blur",
          },
        ],
        paymentDown: [
          {
            required: true,
            message: "请输入订金",
            trigger: "blur",
          },
        ],
        payType: [
          {
            required: true,
            message: "请选择付款方式",
            trigger: "blur",
          },
        ],
        paymentDeal: [
          {
            required: true,
            message: "请输入成交金额",
            trigger: "blur",
          },
        ],
        vehiclePurpose: [
          {
            required: true,
            message: "请选择车辆用途",
            trigger: "blur",
          },
        ],
        isReplace: [
          {
            required: true,
            message: "请选择是否置换",
            trigger: "blur",
          },
        ],
        replacedCarNum: [
          {
            required: true,
            validator: validateReplacedCarNum,
            trigger: "blur",
          },
        ],
        secondDealerName: [
          {
            required: true,
            message: "请输入二级店名",
            trigger: "blur",
          },
        ],
        customerType: [
          {
            required: true,
            message: "请选择客户类型",
            trigger: "blur",
          },
        ],
        customerName: [
          {
            required: true,
            message: "请输入订车人姓名",
            trigger: "blur",
          },
        ],
        identifyType: [
          {
            required: true,
            message: "请选择证件类型",
            trigger: "blur",
          },
        ],
        identifyNo: [
          {
            required: true,
            validator: validateIdentifyNo,
            trigger: "blur",
          },
        ],
        identifyNo2: [
          {
            required: true,
            // validator: validateIdentifyNo2,
            message: "请输入护照",
            trigger: "blur",
          },
        ],
        identifyNo3: [
          {
            required: true,
            message: "请输入合法军官证件号",
            trigger: "blur",
          },
        ],
        identifyNos: [
          {
            required: true,
            message: "请输入证件号码",
            trigger: "blur",
          },
        ],
        customerPhone: [
          {
            required: true,
            validator: validatePhTelNumber,
            trigger: "blur",
          },
        ],
        deliverDate: [
          {
            required: true,
            message: "请选择预计交车时间",
            trigger: "blur",
          },
        ],
        nextFollowDate: [
          {
            required: true,
            message: "请选择下次跟进时间",
            trigger: "blur",
          },
        ],
        images1: [
          {
            required: true,
            message: "请上传合同/协议",
            trigger: "blur",
          },
        ],
        businessType: [
          {
            required: true,
            message: "请选择购车类型",
            trigger: "blur",
          },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      orderTypeDics: [], // 订单类型
      orderLoadDurationDics: [], // 按揭期数
      orderVehiclePurposeDics: [], // 车辆用途
      orderIdentifyTypeDics: [], // 证件类型
      orderStatusDics, // 操作记录标题
      carOptions: [], // 订购车型
      colors: [], //车辆颜色
      vins: [], // 车架号
      orderCancelLog: false,
      timelines: [],
      disabled: true,
      orderCancelForm: {
        reason: "",
      },
      orderCancelRules: {
        reason: [
          {
            required: true,
            validator: (...args) => {
              remarkValidator("取消订单原因", ...args)
            },
            trigger: "blur",
          },
        ],
      },
      confirmLoading: false,
      SubmitLog: false,
      secondDealers: [],
      adressProps: {
        // 省市区信息
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            order_vm.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: order_vm.dealer.dealerId,
                province: "",
                city: "",
              })
              .then(function (res) {
                const provinces = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2,
                }));
                resolve(provinces);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (node.level === 1) {
            order_vm.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: order_vm.dealer.dealerId,
                province: node.value,
                city: "",
              })
              .then(function (res) {
                const cities = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2,
                }));
                resolve(cities);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          if (node.level === 2) {
            order_vm.$httpAuth
              .post("/v2/appCustomerService/orderRegion", {
                dealerId: order_vm.dealer.dealerId,
                province: node.parent.value,
                city: node.value,
              })
              .then(function (res) {
                const countys = res.data.data.map((value) => ({
                  value: value,
                  label: value,
                  leaf: node.level >= 2,
                }));
                resolve(countys);
              })
              .catch((err) => {
                console.log(err);
              });
          }
        },
      },
      show: false,
      oldForm: {},
      customer: {},
      additional: {},
      subLoading: false,
      data: {},
      provinces: [],
      citys: [],
      countys: [],
      showViewer: false,
      // uploadData: {
      //   key: "",
      //   token: "",
      //   url: "",
      // },
      carInternalColor: [],
      carModelOptionalsMaps: {},
      failProductReasonDics: [],
      competitionSeries: [],
      businessTypeOptions: [], // 购车类型
      customerOrder: {}
    };
  },
  computed: {
    isEditing() {
      return this.disabled === false
    },
    carModelOptionalsComputed() {
      let value = {}
      for (const key in this.carModelOptionalsMaps) {
        if(Object.prototype.hasOwnProperty.call(this.carModelOptionalsMaps, key) && this.carModelOptionalsMaps[key] && this.carModelOptionalsMaps[key].some(Boolean)) {
          value[key] = this.carModelOptionalsMaps[key].filter(n => n)
          if(this.isEditing && !this.form.carModelOptionals[key]) {
            this.form.carModelOptionals[key] = (value[key][0] === '无选装' ? '' : value[key][0])
          }
        }
      }
      return value
    }
  },
  created() {
    var baseInfo = this.$common.getBaseInfo();
    this.orderTypeDics = baseInfo.orderTypeDics;
    this.orderLoadDurationDics = baseInfo.orderLoadDurationDics;
    this.orderVehiclePurposeDics = baseInfo.orderVehiclePurposeDics;
    this.orderIdentifyTypeDics = baseInfo.orderIdentifyTypeDics;
    this.failProductReasonDics = baseInfo.failProductReasonDics;
    this.businessTypeOptions = baseInfo.businessTypes;
    this.retrieveCarOptions();
    this.getOrder();
    this.getSecondDealers();
    this.getProvinces();
    this.getCompetitionSeriesesOptions();
  },
  methods: {
    // 返回
    back() {
      if (sessionStorage.getItem("form") === "customerDetail") {
        this.$router.push({
          path: "/customer/detail/" + this.form.customerId,
        });
      } else if (sessionStorage.getItem("form") === "order") {
        this.$router.push({
          path: "/order/zzOrder",
        });
      } else {
        this.$router.go(-1);
      }
    },
    getCompetitionSeriesesOptions() {
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: this.dealer.dealerId,
          key: "",
        })
        .then(res => {
          this.competitionSeries = res.data.data;
        });
    },
    reset() {
      this.code = "";
      this.isSend = true;
      this.time = 60;
    },
    sendSms() {
      if (this.isSend) {
        this.getCode();
      }
      this.isSend = false;
      this.phoneTimer();
    },
    // 手机倒计时
    phoneTimer() {
      if (this.time > 0) {
        this.time--;
        setTimeout(() => {
          this.phoneTimer();
        }, 1000);
      } else {
        this.isSend = true;
        this.time = 60;
      }
    },
    closeViewer() {
      this.showViewer = false;
    },
    uploadBefore(file) {
      const isLt20M = file.size / 1024 / 1024 < 5;
      if (!isLt20M) {
        this.$message.error("上传的图片大小不能超过5MB!");
        return false;
      }
    },
    // 省改变
    provinceChange(val, isClear = true) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: val,
          city: "",
        })
        .then((res) => {
          this.citys = res.data.data;
          if(isClear) {
            this.form.customerCity = "";
            this.form.customerCounty = "";
          }
        });
    },
    // 市改变
    cityChange(val, isClear = true) {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: this.form.customerProvince,
          city: val,
        })
        .then((res) => {
          this.countys = res.data.data;
          if(isClear) {
            this.form.customerCounty = "";
          }
        });
    },
    // 获取省
    getProvinces() {
      this.$httpAuth
        .post("/v2/appCustomerService/orderRegion", {
          dealerId: this.dealer.dealerId,
          province: "",
          city: "",
        })
        .then((res) => {
          this.provinces = res.data.data;
        });
    },
    //合同删除
    // handleRemove1(file) {
    //   if (this.disabled) {
    //     return;
    //   }
    //   let fileList1 = this.$refs.upload1.uploadFiles;
    //   let index = fileList1.findIndex((fileItem) => {
    //     return fileItem.uid === file.uid;
    //   });
    //   fileList1.splice(index, 1);
    //   setTimeout(() => {
    //     this.hideUpload1 = fileList1.length >= 3;
    //   }, 1000);
    //   this.form.images1.splice(index, 1);
    // },
    // //凭证删除
    // handleRemove2(file) {
    //   if (this.disabled) {
    //     return;
    //   }
    //   let fileList2 = this.$refs.upload2.uploadFiles;
    //   let index = fileList2.findIndex((fileItem) => {
    //     return fileItem.uid === file.uid;
    //   });
    //   fileList2.splice(index, 1);
    //   setTimeout(() => {
    //     this.hideUpload2 = fileList2.length >= 3;
    //   }, 1000);
    //   this.form.images2.splice(index, 1);
    // },
    // //点击预览
    // handlePictureCardPreview1(file) {
    //   this.fileList = this.form.images1.map((item) => item.url);
    //   const reg = /^https:\/\/.*$/
    //   this.initialIndex = this.form.images1.findIndex(item => {
    //     if(reg.test(file.url)) {
    //       return item.url == file.url
    //     } else {
    //       return item.url == file.response
    //     }
    //   })
    //   this.showViewer = true;
    // },
    //点击预览
    // handlePictureCardPreview2(file) {
    //   this.fileList = this.form.images2.map((item) => item.url);
    //   const reg = /^https:\/\/.*$/
    //   this.initialIndex = this.form.images2.findIndex(item => {
    //     if(reg.test(file.url)) {
    //       return item.url == file.url
    //     } else {
    //       return item.url == file.response
    //     }
    //   })
    //   this.showViewer = true;
    // },
    //合同改变
    // handleUploadChange1(file, fileList) {
    //   this.hideUpload1 = fileList.length >= 3;
    // },
    // //凭证改变
    // handleUploadChange2(file, fileList) {
    //   this.hideUpload2 = fileList.length >= 3;
    // },
    // //合同上传
    // uploadRequest1(option) {
    //   oss.ossUploadFile(option)
    // },
    // //合同上传成功
    // handleUploadSuccess1(res) {
    //   this.form.images1.push({
    //     url: res
    //   });
    //   console.log(this.form.images1,'form1111111')
    // },
    // //交易凭证上传
    // uploadRequest2(option) {
    //   oss.ossUploadFile(option)
    // },
    // //交易凭证上传成功
    // handleUploadSuccess2(res) {
    //   this.form.images2.push({
    //     url: res
    //   });
    // },
    // 去客户详情
    toCustomer() {
      this.$router.push({
        path: "/customer/detail/" + this.form.customerId,
      });
    },
    parseTime(time, cFormat) {
      if (arguments.length === 0) {
        return null;
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (("" + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === "a")
          return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return time_str;
    },
    retrieveCarOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/vehicleJsonTree", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (response) {
          parent.carOptions = response.data.data;
        });
    },
    changeSpecColor(val) {
      this.form.modelColor = "";
      this.colors = [];
      this.form.carInternalColor = ''
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.getVehicleColor(val)
    },
    getVehicleColor(val) {
      const modelId = val[1];
      this.$httpAuth
        .post("/v2/appCustomerService/vehicleColor", {
          modelId: parseInt(modelId),
          dealerId: this.dealer.dealerId,
        })
        .then((response) => {
          this.colors = response.data.data;
        })
        .catch(() => { });
    },
    async Save() {
      if (this.form.customerAddress != "") {
        if (
          (this.form.customerProvince === "" && this.provinces.length > 0) ||
          (this.form.customerCity === "" && this.citys.length > 0) ||
          (this.form.customerCounty === "" && this.countys.length > 1)
        ) {
          this.$message({
            type: "error",
            message: "订车人省/市/区信息不完整，请选择省/市/区",
          });
          return;
        }
      }
      let skuData = await this.$httpAuth
        .post("v2/appVerifyService/getCarModelSku", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carInternalColor: this.form.carInternalColor,
          carWheelBoss: '',
          carWheel: '',
          choosePackage: '',
          ...this.form.carModelOptionals
        })
      if (!skuData) {
        return
      }
      let params = {
        orderId: this.orderId,
        dealerId: this.dealer.dealerId,
        customerId: Number(this.customerId),
        dealId: Number(this.dealId),
        orderType: this.form.orderType,
        modelId: Number(this.form.modelId[1]),
        modelColor: this.form.modelColor,
        paymentDown: Number(this.form.paymentDown),
        payType: this.form.payType,
        customerType: Number(this.form.customerType),
        customerName:
          Number(this.form.customerType) === 1 ? this.form.customerName : "",
        companyName:
          Number(this.form.customerType) === 2 ? this.form.customerName : "",
        customerPhone: this.form.customerPhone,
        identifyType: this.form.identifyType,
        identifyNo: "",
        customerProvince: this.form.customerProvince,
        customerCity: this.form.customerCity,
        customerCounty: this.form.customerCounty,
        customerAddress: this.form.customerAddress,
        deliverDate: parseInt(this.form.deliverDate / 1000),
        images1: "",
        images2: "",
        nextFollowDate: parseInt(this.form.nextFollowDate / 1000),
        remark: this.form.remark,
        skuCode: skuData.data.skuCode,
        orderReason: this.form.orderReason.join(','),
        competeSeriesId: this.form.competeSeriesId === '' ? 0 : this.form.competeSeriesId,
        businessType: this.form.businessType,
      };
      if (this.form.identifyType === 1) {
        params.identifyNo = this.form.identifyNo;
      } else if (this.form.identifyType === 2) {
        params.identifyNo = this.form.identifyNo2;
      } else if (this.form.identifyType === 3) {
        params.identifyNo = this.form.identifyNo3;
      } else {
        params.identifyNo = this.form.identifyNos;
      }
      // let images1 = [];
      // let images2 = [];
      // this.form.images1.forEach((item) => {
      //   images1.push(item.url);
      // });
      // this.form.images2.forEach((item) => {
      //   images2.push(item.url);
      // });
      params.images1 = getUrls(this.form.images1).join(",");
      params.images2 = getUrls(this.form.images2).join(",");
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          var that = this;
          this.$httpAuth
            .post("/v2/appCustomerService/updateOrder", params)
            .then(function (res) {
              if (res.data.code == 202 && res.data.status== -2) {
                that.confirmLoading = false;
                that.blcInfo = {
                  name: params.customerName,
                  mobile: params.customerPhone,
                  idNo: params.identifyNo,
                  detail: res.data.detail
                }
                that.showBlcTips = true;
                return;
              }
              that.confirmLoading = false;
              if (res.data.orderId) {
                that.disabled = true;
                that.$message({ type: "success", message: "修改成功" });
                that.getOrder();
              }
            })
            .catch(() => {
              that.confirmLoading = false;
              // that.disabled = true;
            });
        }
      });
    },
    // 提交
    handleSubmit() {
      if(!this.form.orderType) {
        this.$message({ type: "error", message: "请选择订单类型" });
        return;
      }
      this.SubmitLog = true;
      this.reset();
    },
    // 提交审批
    Submit() {
      if (!this.needCheckOrder && this.form.images1.length === 0) {
        this.$message({ type: "error", message: "请上传订车合同/协议" });
        return;
      }
      this.subLoading = true;
      var that = this;
      if (this.form.extOrderId != "" && (!this.customerOrder.isLocked || this.data.isUpdate)) {
        this.$httpAuth
          .post("/v2/appCustomerService/orderCheckSms", {
            dealerId: this.dealer.dealerId,
            orderId: this.orderId,
            code: this.code,
          })
          .then((res) => {
            if (res.data.success) {
              this.$httpAuth
                .post("/v2/appCustomerService/submitOrder", {
                  dealerId: this.dealer.dealerId,
                  orderId: this.orderId,
                })
                .then(function (res) {
                  that.subLoading = false;
                  if (res.data.orderId) {
                    that.SubmitLog = false;
                    if (res.data.is_auto_create === 1) {
                      that.$message({ type: "success", message: "提交订单成功，到店登记已自动生成" });
                    } else {
                      that.$message({ type: "success", message: "提交订单成功" });
                    }
                    that.$router.push({
                      path: "/customer/detail/" + that.form.customerId,
                    });
                  }
                })
                .catch(() => {
                  that.subLoading = false;
                  that.SubmitLog = false;
                });
            }
          })
          .catch(() => {
            this.subLoading = false;
          });
      } else {
        this.$httpAuth
          .post("/v2/appCustomerService/submitOrder", {
            dealerId: this.dealer.dealerId,
            orderId: this.orderId,
          })
          .then(function (res) {
            that.subLoading = false;
            if (res.data.orderId) {
              that.SubmitLog = false;
              that.$message({ type: "success", message: "提交订单成功" });
              that.$router.push({
                path: "/customer/detail/" + that.form.customerId,
              });
            }
          })
          .catch(() => {
            that.subLoading = false;
            that.SubmitLog = false;
          });
      }
    },
    //获取核销码
    getCode() {
      if (this.form.extOrderId === "") {
        return;
      }
      this.$httpAuth
        .post("/v2/appCustomerService/orderSendSms", {
          dealerId: this.dealer.dealerId,
          orderId: this.orderId,
        })
        .then(() => { })
        .catch(() => { });
    },
    // 获取订单详情
    getOrder() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderDetail", {
          orderId: this.orderId,
          dealerId: this.dealer.dealerId,
        })
        .then(function (res) {
          let data = res.data;
          that.data = res.data;
          that.timelines = that.data.timelines;
          that.allowTransferAudit = that.data.allowTransferAudit;
          that.allowCancel2 = that.data.allowCancel2;
          that.cannotCancelMsg = that.data.cannotCancelMsg;
          that.needCheckOrder = that.data.needCheckOrder;
          that.remark = that.data.remark;
          that.customerOrder = data.order
          let orderReason =  []
          if (that.data.purchaseInfo&&that.data.purchaseInfo.orderReason != '') {
            orderReason = that.data.purchaseInfo.orderReason.split(',')
          }
          const competeSeriesId = that.data.purchaseInfo && that.data.purchaseInfo.competeSeriesId?that.data.purchaseInfo.competeSeriesId:''
          const { carInternalColor = '', carColor, choicePackage1Name, choicePackage2Name,
            choicePackage3Name, choicePackage4Name, choicePackage5Name, choicePackage6Name, choicePackage7Name, 
            choicePackage8Name, choicePackage9Name
           } = data.carInfo || {}
          that.form = {
            referrerName: data.order.referrerName || '无',
            referrerPhone: data.order.referrerPhone || '无',
            otdStatus: that.data.order.otdStatus,
            extOrderId: that.data.order.extOrderId,
            customerId: that.data.order.customerId,
            // contractNo: that.data.order.contractNo,
            orderType: that.data.order.orderType || "",
            modelId: [],
            modelColor: carColor || that.data.order.modelColor,
            carInternalColor: carInternalColor,
            carModelOptionals: {
              optional1: choicePackage1Name,
              optional2: choicePackage2Name,
              optional3: choicePackage3Name,
              optional4: choicePackage4Name,
              optional5: choicePackage5Name,
              optional6: choicePackage6Name,
              optional7: choicePackage7Name,
              optional8: choicePackage8Name,
              optional9: choicePackage9Name,
            }, // 车型选装
            // modelVin: that.data.order.modelVin,
            // isSanbao: that.data.order.isSanbao,
            paymentDown: that.data.order.paymentDown,
            payType: that.data.order.payType,
            // paymentFirst: that.data.order.paymentFirst,
            // paymentYears: that.data.order.paymentYears,
            // paymentDeal: that.data.order.paymentDeal,
            // paymentOther: that.data.order.paymentOther,
            // mortgagePayment: that.data.order.mortgagePayment,
            // vehiclePurpose: that.data.order.vehiclePurpose,
            // isReplace: that.data.order.isReplace,
            customerType: that.data.order.customerType,
            customerName:
              that.data.order.customerType === 1
                ? that.data.order.customerName
                : that.data.order.companyName,
            customerPhone: that.data.order.customerPhone,
            identifyType: that.data.order.identifyType,
            identifyNo: that.data.order.identifyNo,
            identifyNos: that.data.order.identifyNo,
            identifyNo2: that.data.order.identifyNo,
            identifyNo3: that.data.order.identifyNo,
            customerAddress: that.data.order.customerAddress,
            deliverDate: that.data.order.deliverDate ? that.data.order.deliverDate * 1000 : '',
            // isReport: that.data.order.isReport,
            remark: that.data.order.remark,
            // isOtherDealer: that.data.order.isOtherDealer,
            // replacedCarNum: that.data.order.replacedCarNum,
            // isSaledBySecond: that.data.order.isSaledBySecond,
            // secondDealerName: that.data.order.secondDealerName,
            nextFollowDate: "",
            customerProvince: that.data.order.customerProvince,
            customerCity: that.data.order.customerCity,
            customerCounty: that.data.order.customerCounty,
            images1: [],
            images2: [],
            orderReason,
            competeSeriesId,
            businessType: that.data.order.businessType || '',
            reactivateSource: that.data.reactivateSource || '',
            sourceName: that.data.sourceName || ''
          };
          if (that.data.order.customerProvince != '') {
            that.provinceChange(that.data.order.customerProvince, false);
          }
          if (that.data.order.customerCity) {
            that.cityChange(that.data.order.customerCity, false);
          }
          setTimeout(() => {
            that.form.customerCity = that.data.order.customerCity;
            that.form.customerCounty = that.data.order.customerCounty;
          }, 300);
          // that.fileList1 = [];
          // that.fileList2 = [];
          if (that.data.order.images1 != "") {
            that.form.images1 = that.data.order.images1.split(",")
          }
          if (that.data.order.images2 != "") {
            that.form.images2 = that.data.order.images2.split(",")
          }
          that.hideUpload1 = that.form.images1.length >= 3;
          that.hideUpload2 = that.form.images2.length >= 3;
          that.show = true;
          that.getmodelId(that.data.order.modelId);
          that.geCustomerInfo();
        })
        .catch(() => { });
    },
    formatReferrerName(str = '') {
      return str.replace(/^(.{1})(.*)$/, (match, p1, p2) => p1 + p2.replace(/./g, '*')) || '--'
    },
    formatReferrerPhone(str = '') {
      return str.replace(/^(.{3})(.*)(.{4})$/, (match, p1, p2, p3) => p1 + p2.replace(/./g, '*') + p3) || '--'
    },
    getmodelId(id) {
      var that = this;
      this.$httpAuth
        .post("/v1/baseRpc/getSpec", {
          id: id,
        })
        .then(function (res) {
          that.form.modelId = [
            res.data.spec.seriesId + "",
            res.data.spec.id + "",
          ];
          that.getVehicleColor(that.form.modelId);
          that.form.modelColor = that.data.carInfo ? that.data.carInfo.carColor : that.data.order.modelColor;
          // that.form.carInternalColor = res.data.spec.carInternalColor;
          that.getCarModelDetail();
          that.getCarModelOptionals()
          that.oldForm = JSON.parse(JSON.stringify(that.form));
        })
        .catch(() => { });
    },
    getCarModelDetail() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelDetail", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carWheelBoss: '',
          carWheel: '',
          carInternalColor: this.form.carInternalColor,
        }).then(res => {
          this.carInternalColor = [...res.data.carInternalColor];
          if(this.isEditing && this.carInternalColor && this.carInternalColor[0]) {
            this.form.carInternalColor = this.carInternalColor[0]
            this.getCarModelOptionals()
          }
          const isHasInternalColor = this.carInternalColor.some(Boolean)
          if(!isHasInternalColor) {
            this.getCarModelOptionals()
          }
        })
    },
    getCarModelOptionals() {
      this.$httpAuth
        .post("/v2/appVerifyService/getCarModelOptionals", {
          dealerId: this.dealer.dealerId,
          modelId: Number(this.form.modelId[1]),
          carExternalColor: this.form.modelColor,
          carInternalColor: this.form.carInternalColor
        })
        .then((res) => {
          this.carModelOptionalsMaps = res.data;
        });
    },
    modelColorChange() {
      this.form.carInternalColor = ''
      this.getCarModelDetail();
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
    },
    carInternalColorChange() {
      // 选装重置
      Object.keys(this.form.carModelOptionals).forEach(key => {
        this.form.carModelOptionals[key] = "";
      });
      this.carModelOptionalsMaps = {}
      this.getCarModelOptionals()
    },
    // 取消订单
    orderCancel() {
      if (this.allowCancel2) {
        this.orderCancelForm = {
          reason: "",
        };
        this.orderCancelLog = true;
      } else {
        this.orderCancelLog2 = true;
      }
    },
    // 取消订单确定
    orderCanceConfim() {
      this.$refs["orderCancelForm"].validate((valid) => {
        if (valid) {
          var that = this;
          that.confirmLoading = true;
          this.$httpAuth
            .post("/v2/appCustomerService/cancelOrder", {
              dealerId: this.dealer.dealerId,
              orderId: this.orderId,
              reason: this.orderCancelForm.reason,
            })
            .then(function () {
              that.$message({
                type: "success",
                message: "取消订单成功",
              });
              that.confirmLoading = false;
              that.orderCancelLog = false;
              that.$router.push({
                path: "/orderCancel",
                query: { id: that.orderId },
              });
            })
            .catch(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
    // 获取二级店
    getSecondDealers() {
      var that = this;
      this.$httpAuth
        .post("/v2/appCustomerService/orderSecondDealers", {
          dealerId: this.dealer.dealerId,
        })
        .then(function (res) {
          that.secondDealers = res.data.data;
        })
        .catch(() => { });
    },
    // 取消
    Cancel() {
      this.disabled = true;
      this.$refs.form.clearValidate()
      this.form = JSON.parse(JSON.stringify(this.oldForm));
    },
    geCustomerInfo() {
      this.$httpAuth
        .post("/v2/appCustomerService/get", {
          dealerId: this.dealer.dealerId,
          customerId: this.form.customerId,
        })
        .then((res) => {
          this.customer = { ...res.data.customer };
          this.additional = { ...res.data.additional };
        });
    },
    customerTypeChange(val) {
      if (val === 1) {
        this.form.customerName = this.customer.name;
      } else {
        this.form.customerName = this.customer.companyName;
      }
    },
    identifyTypeChange() {
      this.form.identifyNo = "";
      this.form.identifyNo2 = "";
      this.form.identifyNo3 = "";
      this.form.identifyNos = "";
      //   if (val === 1) {
      //     this.form.identifyNo = this.additional.idNo
      //   } else {
      //     this.form.identifyNos = ''
      //   }
    },
  },
  watch: {},
  filters: {
    orderStatus(val) {
      for (var i = 0; i < order_vm.orderStatusDics.length; i++) {
        var o = order_vm.orderStatusDics[i];
        if (o.orderStatus == val) {
          return o.name;
        }
      }
      return "";
    },
  },
};
</script>
<style scoped>
.back {
  font-size: 14px;
}

.el-step__title {
  font-size: 14px;
}

.mt2 {
  margin-top: 20px;
}

.mt1 {
  margin-top: 10px;
}

.title {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: rgba(10, 18, 32, 0.64);
  letter-spacing: normal;
  margin-bottom: 15px;
  margin-top: 10px;
}

.form_item {
  margin-bottom: 15px !important;
}

.tips {
  width: 100%;
  text-align: center;
  font-weight: 600;
  margin-bottom: 20px;
}

.submit-fo {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.ps {
  width: 100%;
  text-align: center;
  height: 50px;
  font-size: 12px;
  line-height: 40px;
}

.pss {
  width: 100%;
  height: 50px;
  font-size: 12px;
  line-height: 20px;
}

.boxLine {
  width: 250px;
  padding: 5px 0 5px 10px;
  border: 1px solid #e8ebed;
  font-size: 12px;
}

.boxLine .title {
  font-weight: 600;
  color: #000;
}

.el-timeline-item__wrapper {
  position: relative;
}

.el-timeline-item__timestamp {
  position: absolute;
  left: -110px;
  top: 0;
}

.toCustomer {
  color: rgb(64, 158, 255);
  cursor: pointer;
  margin-left: 10px;
  font-weight: 400;
}

.hide .el-upload--picture-card {
  display: none;
}

.el-upload-list__item {
  width: 90px !important;
  height: 90px !important;
}

.el-upload {
  width: 90px !important;
  height: 90px !important;
  line-height: 90px !important;
}
</style>
